import { connect, ConnectedProps } from 'react-redux'

import MenuItem from 'components/dealwatch/header/MenuItem'
import { setSignUpModalIsOpen } from 'redux/actions'
import { RootState, AppDispatch } from 'redux/store'

const mapStateToProps = (state: RootState): { currentUrl: RootState['layout']['url'], flavour: RootState['layout']['flavour'], isLogged: RootState['user']['isLogged'] } => ({
  currentUrl: state.layout.url,
  flavour: state.layout.flavour,
  isLogged: state.user.isLogged
})

const mapDispatchToProps = (dispatch: AppDispatch): { setSignUpModalIsOpen: (isOpen: boolean) => ReturnType<AppDispatch> } => ({
  setSignUpModalIsOpen: (isOpen: boolean) => dispatch(setSignUpModalIsOpen(isOpen))
})

const connector = connect(mapStateToProps, mapDispatchToProps)

export type MenuItemContainerProps = ConnectedProps<typeof connector>

export default connector(MenuItem)
